/**
 * La cruz de Farmacia San Carlos, en el lienzo de 64 unidades del sello.
 *
 * Es la cruz del letrero de la farmacia: dos piezas que se abrazan en
 * diagonal, una arriba a la izquierda y otra abajo a la derecha. En el letrero
 * la de arriba es azul violeta y la de abajo verde; sobre la placa azul del
 * sello la de arriba va en blanco, que es lo que se lee a 18 px.
 *
 * LA GEOMETRIA
 * Brazos de 14 de ancho (25 a 39) y 36 de largo (14 a 50), puntas redondeadas
 * con radio 4. La diagonal que separa las piezas, x + y = 64, entra y sale
 * justo por las dos esquinas interiores —(39, 25) y (25, 39)—, asi que cada
 * pieza es un poligono limpio: la de arriba se queda los brazos superior e
 * izquierdo, la de abajo el derecho y el inferior, y el cuadro central se
 * parte en dos triangulos.
 *
 * Entre las dos piezas queda una ranura de 2.4 unidades (1.2 a cada lado de la
 * diagonal) por donde asoma la placa. En las versiones de una sola tinta —el
 * ticket termico, el corte impreso— esa ranura es lo unico que dice que la
 * cruz son dos piezas, asi que no se quita.
 *
 * Como la cruz es simetrica no hace falta el ajuste optico que llevaba la Z de
 * Zuniga: su centro de masa y el de su caja coinciden en (32, 32).
 *
 * ESTE MODULO ES LA FUENTE. `public/icons/icon.svg` y
 * `scripts/generate-icons.mjs` llevan copia de estas coordenadas porque uno es
 * un archivo estatico y el otro un script de Node sin bundler; si se retoca la
 * cruz hay que tocar los tres y volver a correr el generador de iconos.
 */

/** Pieza de arriba a la izquierda: brazo superior, brazo izquierdo y medio centro. */
export const MARK_UPPER_PATH =
  'M39 23.8V18A4 4 0 0 0 35 14H29A4 4 0 0 0 25 18V25H18A4 4 0 0 0 14 29V35A4 4 0 0 0 18 39H23.8Z';

/** Pieza de abajo a la derecha: brazo derecho, brazo inferior y la otra mitad del centro. */
export const MARK_LOWER_PATH =
  'M40.2 25H46A4 4 0 0 1 50 29V35A4 4 0 0 1 46 39H39V46A4 4 0 0 1 35 50H29A4 4 0 0 1 25 46V40.2Z';

/** Colores del sello a color, los mismos del icono y del generador de PNG. */
export const MARK_COLORS = {
  /** Placa: azul claro arriba a la izquierda -> azul rey -> azul noche. */
  plate: ['#6B92F5', '#2A52BE', '#102C7A'],
  /** Pieza de arriba: blanco con un velo azul abajo. */
  upper: ['#FFFFFF', '#EAF0FF'],
  /** Pieza de abajo: el verde del letrero, con luz arriba. */
  lower: ['#A8DB6E', '#6AA637'],
  /** Placa en una sola tinta, para el ticket impreso a color. */
  plateFlat: '#2A52BE',
  /** Verde plano, para el ticket impreso a color. */
  lowerFlat: '#7AB648',
} as const;
